<template lang="pug">
  .ui-upload
    b-upload(v-model="dropFiles" :multiple="multiple" v-bind="$attrs" v-on="$listeners")
      template(v-if="simple")
        a.button
          b-icon(icon="upload")
          span Выбрать файлы
      template(v-else)
        div.has-text-centered
          p: b-icon(icon="upload" size="is-large")
          p Перетащите файлы сюда или нажмите, чтобы загрузить

    div.mt-10(v-if="dropFiles && dropFiles.length")
      b-button.is-full.mt-5.pr-5(v-for="(file, index) in dropFiles" :key="index" :type="listStyle")
        ui-file-preview.mr-10(:file="file")
        .is-pulled-right
          //b-tag {{ (new FileHelper(file)).getHumanSize(0) }}
          span.py-5.px-10(@click.prevent.stop="deleteDropFile(index)"): b-icon(icon="close")
        small {{ fileName(file.name) }}
        //.control: b-button.is-dark(icon-left="close" )

        //hr
    //.table.is-fullwidth.is-narrow.mt-10: tbody
      tr(v-for="(file, index) in dropFiles")
        //b-table-column(field="icon" label="" width="1"):
        td(width="100%")
          ui-file-icon.mr-5(:file="file")
          small {{ file.name }}
        //td(field="size" label="Размер") {{ humanFileSize(file.size) }}
        td(width="1")
          a(@click.prevent="deleteDropFile"): b-icon(icon="close-circle" type="is-danger")
          //b-button( size="is-small" type="is-danger" icon-left="close")

</template>

<script>
import FileHelper from '@/helpers/file';
import BButton from 'buefy/src/components/button/Button';
import BTag from 'buefy/src/components/tag/Tag';
import BTableColumn from 'buefy/src/components/table/TableColumn';
import BTable from 'buefy/src/components/table/Table';

export default {
  name: 'ui-upload',
  components: { BTable, BTableColumn, BTag, BButton },

  props: {
    value: [Object, Array],
    multiple: Boolean,
    simple: Boolean,
    wide: Boolean,
    listStyle: {
      type: String,
      default: () => 'is-dark',
    },
  },

  watch: {
    dropFiles() {
      this.$emit('input', this.dropFiles);
    },
    value(value) {
      this.dropFiles = value;
    },
  },

  data: () => ({
    dropFiles: [],
  }),

  methods: {
    FileHelper,
    fileExtension(file) {
      return new FileHelper(file).getExtension();
    },
    fileName(filename) {
      const size = this.wide ? 60 : 26;
      if (filename.length > size) {
        return filename.slice(0, size / 2) + '…' + filename.slice(-size / 2);
      }
      return filename;
    },
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.ui-upload {
  .upload .upload-draggable {
    display: block;
    width: 100%;
  }
}
</style>
